function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.2501 7.69657C10.9799 7.69657 11.5716 7.10494 11.5716 6.37514C11.5716 5.64533 10.9799 5.05371 10.2501 5.05371C9.52033 5.05371 8.92871 5.64533 8.92871 6.37514C8.92871 7.10494 9.52033 7.69657 10.2501 7.69657Z",
  fill: "#4D88FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.25 20.25C15.3586 20.25 19.5 16.1086 19.5 11C19.5 5.89137 15.3586 1.75 10.25 1.75C5.14137 1.75 1 5.89137 1 11C1 16.1086 5.14137 20.25 10.25 20.25Z",
  stroke: "#4D88FF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.25 16.2857V11",
  stroke: "#4D88FF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgPoStatusInfo = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgPoStatusInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/po_status_info.ff5cfc5f.svg";
export { ForwardRef as ReactComponent };